module.exports = __webpack_public_path__ + "img/ryan-d.318a5786.png";